module.exports = __webpack_public_path__ + "static/diagnoson-40-anos-positivo-2f22f21b8c84ac75475859d73d9da3b6.svg";